import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { thousands } from '../../formatting.js';
import Highlighter from '../Highlighter/Highlighter.js';
import styles from './ClanResource.module.scss.js';

var ClanResource = (function (_super) {
    __extends(ClanResource, _super);
    function ClanResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClanResource.prototype.render = function () {
        var _a;
        var classClanResource = classNames(styles.resource, (_a = {},
            _a[styles.isMuted] = !!this.props.isMuted,
            _a[styles.isNotEnough] = !!this.props.isNotEnough,
            _a[styles.isFlat] = !!this.props.isFlat,
            _a));
        return (React.createElement(Highlighter, { className: classNames(classClanResource, this.props.className), value: thousands(this.props.amount) }));
    };
    return ClanResource;
}(React.PureComponent));

export { ClanResource as default };
//# sourceMappingURL=ClanResource.js.map
